import {UtilService} from '../services/util.service';

export class LayoutSeat {
  y: number;
  z: number;
  seats?: Seat[];
  constructor(data: any) {
    if (data) {
      Object.assign(this, data);
      this.seats = data.seats ? data.seats.map(value => new Seat(value)) : [];
    }
  }
}

export class Seat {

  number: string;
  positionX: number;
  positionY: number;
  positionZ: number;
  status: string;
  reservationId?: any;

  selected?: boolean;
  seatImg: string;

  constructor(data: any) {
    if (data) {
      Object.assign(this, data);
      this.setImgValue();
    }
  }

  setImgValue(){
    if(this.status == 'SOLD' || this.status == 'UNAVAILABLE'){
      this.seatImg = UtilService.imgUrlPrefix +  UtilService.carNormal;
    }
    else if( this.status == 'VACANT' ){
      this.seatImg = UtilService.imgUrlPrefix +  UtilService.carGreen;
    }
    else if ( this.status == 'RESERVED' ) {
      this.seatImg = UtilService.imgUrlPrefix +  UtilService.carOrange;
    }
  }

  isVacant() {
    return this.status == 'VACANT' ? true : false;
  }

  setVacant() {
    this.status = 'VACANT';
    this.setImgValue();
  }

  setReserved() {
    this.status = 'RESERVED';
    this.setImgValue();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/model/BusLayout.ts